module.exports = __webpack_public_path__ + "img/meditation_10.9ef6d8f3.svg";